import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons/lib/icons';
import './RDLoader.scss';

const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const RDLoader = ({ children, displayLoader, loaderTip, loaderSize }) => (
  <Spin indicator={loadingIcon} spinning={displayLoader} tip={loaderTip} size={loaderSize}>
    {children}
  </Spin>
);

RDLoader.defaultProps = {
  loaderTip: 'Loading...',
  displayLoader: false,
  loaderSize: 'default',
};

RDLoader.propTypes = {
  /** Customize loader description content */
  loaderTip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Whether the loader is visible or not */
  displayLoader: PropTypes.bool,
  /** Size of the loader */
  loaderSize: PropTypes.oneOf(['default', 'small', 'large']),
  /** React Node */
  children: PropTypes.element.isRequired,
};

export default RDLoader;
